<script lang="ts" setup>
import useFeatureFlags from '@/composables/feature-flags';
import type { FeatureFlagOverrides } from '@/types/models/flag';

defineOptions({ inheritAttrs: false });

const flags = useFeatureFlags();
</script>

<template>
  <BasePopover placement="top-start">
    <template #control="{ toggle }">
      <button v-bind="$attrs" class="unstyled-button menu-launcher tw-dark" @click="toggle">
        <BaseIcon class="menu-icon" name="flag" colour="on-fill" size="large" />
      </button>
    </template>
    <template #content>
      <div class="popover-content">
        <BaseHeading size="md" class="mb-4x">{{ $t('components.ff.featureFlags') }}</BaseHeading>
        <template
          v-for="[key, item] in Object.entries(flags.flagsWithOverrides as FeatureFlagOverrides)"
          :key="key"
        >
          <div :uid="key" class="flex gap-1.5x">
            <BaseSwitch
              :model-value="item.enabled"
              :label="key"
              class="mb-4x flex-1"
              @update:model-value="(val) => flags.setOverride(key, val)"
            />
            <BaseTooltip v-if="item.local" :text="$t('components.ff.localStorage')">
              <BaseIcon name="folder_open" />
            </BaseTooltip>
          </div>
        </template>
        <a @click="flags.resetAllOverrides()">{{ $t('components.ff.reset') }}</a>
      </div>
    </template>
  </BasePopover>
</template>

<style scoped>
.menu-launcher {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--background-color-strong-neutral);
  box-shadow:
    0 1px 6px 0 rgb(0 0 0 / 6%),
    0 2px 32px 0 rgb(0 0 0 / 16%);
  transition: background 150ms ease;
}

.menu-launcher:hover {
  background: var(--background-color-strong-neutral-hover);
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  transition:
    transform 100ms linear,
    opacity 80ms linear;
}

.popover-content {
  width: 450px;
  min-height: 220px;
  max-height: calc(100vh - 100px);
  box-sizing: border-box;
  padding: 20px;
  overflow-y: scroll;
}
</style>
